import React from 'react';
import { motion } from 'framer-motion';

export default function SuccessModal({ message }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 50, scale: 0.9 }}
      className="fixed bottom-28 left-4 right-4 z-50 flex justify-center"
    >
      <div className="bg-sage-700 text-white px-6 py-4 rounded-2xl shadow-xl shadow-sage-400/30
                      flex items-center gap-3 max-w-sm">
        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-sm font-medium">{message}</p>
      </div>
    </motion.div>
  );
}
